import React from 'react';
import { withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import CURRENT_USER from '../../../../GraphQl/Queries/CURRENT_USER';
import GET_SIGNED_URL from '../../../../GraphQl/Queries/GET_SIGNED_URL';
import OverlaySpinner from '../../../../../platform/shared/OverlaySpinner';
import ErrorPage from '../../../../../platform/shared/ErrorPage';

const SessionLoader = (props) => {
  const { reportKey } = props;
  const {
    data: signedURL,
    loading: signedURLsLoading,
    error: signedURLsError,
  } = useQuery(GET_SIGNED_URL, {
    variables: {
      key: reportKey,
    },
    fetchPolicy: 'no-cache',
    skip: !reportKey || reportKey === '',
  });

  if (signedURLsLoading) return <OverlaySpinner />;
  if (signedURLsError) return <ErrorPage />;
  return React.cloneElement(props.children, {
    ...props.children.props,
    signedURL,
  });
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withRouter(SessionLoader));
